import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/WetuGardens";

const WetuGardens = () => {
  const projectId = "PRJ00056";
  const title = "Kibali Cha Watoto - Wetu Gardens - Malindi Phase 6";

  const mapConfig = {
    minZoom: 11,
    zoom: 12,
    bounds: [
      [-15.91, -104.73],
      [-16.31, -104.3],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/kibali-cha-watoto-wetu-gardens/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSfUk18QyvFvwUHYZN1zGwrBZTWNdqXMQIKogDhaGZc7FA9AwA/viewform"
    />
  );
};

export default WetuGardens;
